export const getPaymentsCredits = (state) =>
  state.payments.paymentsCredits.credits;
export const getFetchPaymentsCreditsLoaded = (state) =>
  state.payments.paymentsCredits.loaded;
export const getFetchPaymentsCreditsError = (state) =>
  state.payments.paymentsCredits.error;
export const getSavePaypalPaymentError = (state) =>
  state.payments.payPalPayment.error;
export const getSavePaypalPaymentLoaded = (state) =>
  state.payments.payPalPayment.loaded;
export const isAutomaticRechargeLoaded = (state) =>
  state.payments.automaticRecharge.loaded;
export const getAutomaticRechargeError = (state) =>
  state.payments.automaticRecharge.error;
export const getAutomaticRechargeUrl = (state) =>
  state.payments.automaticRecharge.url;
export const getAutomaticPaymentData = (state) =>
  state.payments.automaticPayment.data;
export const isAutomaticPaymentError = (state) =>
  state.payments.automaticPayment.error;
export const isAutomaticPaymentLoaded = (state) =>
  state.payments.automaticPayment.loaded;
export const isEditingAutomaticRechargeLoaded = (state) =>
  state.payments.automaticRecharge.loadedOperation;
export const isEditingAutomaticRechargeError = (state) =>
  state.payments.automaticRecharge.errorOperation;
export const isEditingAutomaticRechargeSuccess = (state) =>
  state.payments.automaticRecharge.successOperation;
export const isCreditRechargeLoaded = (state) =>
  state.payments.recharge.loaded;
export const isCreditRechargeError = (state) =>
  state.payments.recharge.error;
export const getCreditRechargeUrl = (state) =>
  state.payments.recharge.url;